/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalSignerType = {
    CUSTOMER: 'CUSTOMER',
    PROSPECT: 'PROSPECT'
};
